import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import { store } from '../../store';
import * as actions from '../../store/actions';
import {
  FormRow,
  FormColumn,
  TextMedium,
  Card,
  ButtonTransparent,
} from '../../components';
import flagBrazil from "../../assets/icons/FlagBrasil.png";
import flagEngland from "../../assets/icons/FlagEngland.jpg";
import flagSpain from "../../assets/icons/FlagSpain.jpg";

const LanguageSelection = (props) => {
  const {
    dimensions,
    currentStep,
    reRender,
    setReRender,
    alwaysVisible = false,
  } = props;

  const buttonStyle = {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    backgroundColor: '#f3f4f6',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
  }

  if (alwaysVisible || currentStep === 1 || currentStep === 4) {
    return (
      <FormColumn width={dimensions.width - 45} justifyContent='center' alignItems='center' paddingTop={10}>
        <FormRow justifyContent='center'>
          <ButtonTransparent
            padding={3}
            onPress={() => {
              store.dispatch(actions.setLanguage({ lang: 'pt-br' }));
              setReRender(!reRender);
            }}
          >
            <div style={buttonStyle}>
              <img
                src={flagBrazil}
                alt="Brazil"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
          </ButtonTransparent>
          <ButtonTransparent
            padding={3}
            onPress={() => {
              store.dispatch(actions.setLanguage({ lang: 'en' }));
              setReRender(!reRender);
            }}
          >
            <div style={buttonStyle}>
              <img
                src={flagEngland}
                alt="England"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
          </ButtonTransparent>
          <ButtonTransparent
            padding={3}
            onPress={() => {
              store.dispatch(actions.setLanguage({ lang: 'sp' }));
              setReRender(!reRender);
            }}
          >
            <div style={buttonStyle}>
              <img
                src={flagSpain}
                alt="Spain"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
          </ButtonTransparent>
        </FormRow>
      </FormColumn>
    )
  }
  return null;
};

export default LanguageSelection;
